var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _g, _path325, _g2, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _g3, _path335, _path336, _path337, _path338, _path339, _g4, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _g5, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _g6, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _g7, _path440, _path441, _path442, _g8, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _g9, _g10, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1249 967",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3692 950.424L0.199215 384.475C-0.970785 370.062 3.04021 355.705 11.5092 343.985L241.879 25.1451C248.036 16.6271 256.299 9.85316 265.859 5.48715C275.419 1.12015 285.95 -0.688852 296.419 0.235148L1085.06 69.7751C1097.54 70.8731 1109.38 75.8091 1118.95 83.9041C1128.51 91.9981 1135.34 102.855 1138.49 114.985L1246.84 531.985C1249.51 542.238 1249.45 553.013 1246.66 563.235L1140.66 951.834L46.3692 950.424Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.799 482.039H232.439V965H240.799V482.039Z",
    fill: "#DADDDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M349.469 482.039H341.109V965H349.469V482.039Z",
    fill: "#DADDDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.77 456.961H415.41V939.92H423.77V456.961Z",
    fill: "#DADDDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.439 463.461H265.869V946.42H271.439V463.461Z",
    fill: "#DADDDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M434.909 536.828H237.939V544.258H434.909V536.828Z",
    fill: "#DADDDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.531 634.359H234.561V641.789H431.531V634.359Z",
    fill: "#DADDDF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M425.221 761.602H234.641V769.032H425.221V761.602Z",
    fill: "#DADDDF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M424.881 829.398H234.301V836.828H424.881V829.398Z",
    fill: "#DADDDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M535.141 337.02H526.971V881.43H535.141V337.02Z",
    fill: "#DADDDF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M641.311 337.02H633.141V881.43H641.311V337.02Z",
    fill: "#DADDDF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M713.891 312.52H705.721V856.93H713.891V312.52Z",
    fill: "#DADDDF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M565.081 318.871H559.641V863.281H565.081V318.871Z",
    fill: "#DADDDF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M724.78 472.211H532.35V479.471H724.78V472.211Z",
    fill: "#DADDDF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M721.481 567.488H529.051V574.748H721.481V567.488Z",
    fill: "#DADDDF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M715.311 691.789H529.131V699.049H715.311V691.789Z",
    fill: "#DADDDF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M714.969 758.031H528.789V765.291H714.969V758.031Z",
    fill: "#DADDDF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M944.83 881.43H954.34V337.02H944.83V881.43Z",
    fill: "#DADDDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M821.14 881.43H830.65V337.02H821.14V881.43Z",
    fill: "#DADDDF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M736.56 856.93H746.07V312.52H736.56V856.93Z",
    fill: "#DADDDF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M909.94 863.289H916.28V318.879H909.94V863.289Z",
    fill: "#DADDDF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M723.87 479.48H948.08V472.221H723.87V479.48Z",
    fill: "#DADDDF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M720.46 574.738H951.93V567.478H720.46V574.738Z",
    fill: "#DADDDF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M734.9 699.059H951.83V691.799H734.9V699.059Z",
    fill: "#DADDDF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M735.3 765.289H952.23V758.029H735.3V765.289Z",
    fill: "#DADDDF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.76 966.45H26.129C25.912 966.49 25.689 966.47 25.477 966.41C25.264 966.36 25.067 966.25 24.899 966.11C24.731 965.97 24.596 965.79 24.504 965.59C24.411 965.39 24.363 965.17 24.363 964.95C24.363 964.73 24.411 964.51 24.504 964.31C24.596 964.11 24.731 963.93 24.899 963.79C25.067 963.65 25.264 963.54 25.477 963.49C25.689 963.43 25.912 963.41 26.129 963.45H1169.76C1170.11 963.51 1170.44 963.69 1170.67 963.97C1170.91 964.24 1171.03 964.59 1171.03 964.95C1171.03 965.31 1170.91 965.66 1170.67 965.93C1170.44 966.21 1170.11 966.39 1169.76 966.45Z",
    fill: "#B2B6BB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.361 509.898H190.641V536.828H192.361V509.898Z",
    fill: "#61656D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M200.13 509.898H198.41V536.828H200.13V509.898Z",
    fill: "#61656D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M206.159 509.898H204.439V536.828H206.159V509.898Z",
    fill: "#61656D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M214.79 509.898H213.07V536.828H214.79V509.898Z",
    fill: "#61656D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M380.909 482.039H379.189V508.969H380.909V482.039Z",
    fill: "#61656D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M388.669 482.039H386.949V508.969H388.669V482.039Z",
    fill: "#61656D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M394.701 482.039H392.98V508.969H394.701V482.039Z",
    fill: "#61656D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M403.329 482.039H401.609V508.969H403.329V482.039Z",
    fill: "#61656D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.51 536.828H199.93V580.478H218.51V536.828Z",
    fill: "#B2B6BB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M407.98 508.969H389.4V580.489H407.98V508.969Z",
    fill: "#B2B6BB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M453.351 511.762H451.631V538.692H453.351V511.762Z",
    fill: "#61656D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M461.111 511.762H459.391V538.692H461.111V511.762Z",
    fill: "#61656D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M467.15 511.762H465.43V538.692H467.15V511.762Z",
    fill: "#61656D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M475.771 511.762H474.051V538.692H475.771V511.762Z",
    fill: "#61656D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M480.43 538.691H461.85V582.341H480.43V538.691Z",
    fill: "#B2B6BB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M470.21 538.691H446.99V582.341H470.21V538.691Z",
    fill: "#DADDDF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M287.101 521.051H285.381V547.981H287.101V521.051Z",
    fill: "#61656D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M294.861 521.051H293.141V547.981H294.861V521.051Z",
    fill: "#61656D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M300.9 521.051H299.18V547.981H300.9V521.051Z",
    fill: "#61656D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M309.521 521.051H307.801V547.981H309.521V521.051Z",
    fill: "#61656D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M314.18 547.051H295.6V582.341H314.18V547.051Z",
    fill: "#B2B6BB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M511.999 580.488H379.189V962.5H511.999V580.488Z",
    fill: "#B2B6BB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M218.639 711.891H209.119V786.881H218.639V711.891Z",
    fill: "#B2B6BB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M212.779 711.891V786.891H280.779V711.891H212.779ZM277.159 782.711H216.159V715.341H277.159V782.711Z",
    fill: "#868A91"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M312.45 711.891H302.93V786.881H312.45V711.891Z",
    fill: "#B2B6BB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M306.59 711.891V786.891H374.54V711.891H306.59ZM371 782.711H310V715.341H371V782.711Z",
    fill: "#868A91"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M218.639 608.801H209.119V683.791H218.639V608.801Z",
    fill: "#B2B6BB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M312.45 608.801H302.93V683.791H312.45V608.801Z",
    fill: "#B2B6BB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M218.639 812.199H209.119V887.189H218.639V812.199Z",
    fill: "#B2B6BB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M212.779 812.199V887.199H280.779V812.199H212.779ZM277.159 882.999H216.159V815.639H277.159V882.999Z",
    fill: "#868A91"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M397.76 580.49V509H374.54V580.52H304V547.05H280.74V580.49H209.22V536.83H186V963.14H398V580.49H397.76ZM280.76 887.19H209.12V812.19H280.74L280.76 887.19ZM280.76 786.88H209.12V711.88H280.74L280.76 786.88ZM280.76 683.79H209.12V608.79H280.74L280.76 683.79ZM374.56 887.19H302.93V812.19H374.54L374.56 887.19ZM374.56 786.88H302.93V711.88H374.54L374.56 786.88ZM374.56 683.79H302.93V608.79H374.54L374.56 683.79Z",
    fill: "#DADDDF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M312.45 812.199H302.93V887.189H312.45V812.199Z",
    fill: "#B2B6BB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M306.59 812.199V887.199H374.54V812.199H306.59ZM371 882.999H310V815.639H371V882.999Z",
    fill: "#868A91"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M757.619 375.129V963H1001.52V375.129H757.619ZM882.62 520.369H810.719V418.599H882.62V520.369ZM977.62 785.159H905.73V683.399H977.62V785.159ZM977.62 652.769H905.73V550.999H977.62V652.769ZM977.62 520.369H905.73V418.599H977.62V520.369Z",
    fill: "#1F33AC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M977.56 683.398H966.64V785.168H977.56V683.398Z",
    fill: "#1C1C1C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M977.56 683.398H966.64V785.168H977.56V683.398Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M977.56 683.398H966.64V785.168H977.56V683.398Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 683.398H810.68V785.168H882.58V683.398Z",
    fill: "#F4F4F4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 683.398H871.66V785.168H882.58V683.398Z",
    fill: "#1C1C1C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M882.58 683.398H871.66V785.168H882.58V683.398Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M882.58 683.398H871.66V785.168H882.58V683.398Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M810.68 785.16H875.48V683.39H810.68V785.16Z",
    fill: "#3F4249"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M843.08 778.25H871.23V689.33H843.08V778.25Z",
    fill: "#F4F4F4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M843.08 778.25H871.23V689.33H843.08V778.25Z",
    fill: "#1C1C1C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M810.679 778.25H839.36V689.33H810.679V778.25Z",
    fill: "#F4F4F4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M810.679 778.25H839.36V689.33H810.679V778.25Z",
    fill: "#1C1C1C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M810.68 689.328L839.36 766.388V778.248H836.71L810.68 711.058V689.328Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M810.68 689.328H813.28L839.36 760.708V766.388L810.68 689.328Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M815.309 689.328L839.36 755.128V757.018L814.619 689.328H815.309Z",
    fill: "#E4E4ED"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M817.589 689.328L839.36 748.608V753.618L815.859 689.328H817.589Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M815.861 689.328L839.36 753.618V755.128L815.311 689.328H815.861Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M830.33 689.328L839.36 712.748V719.678L827.54 689.328H830.33Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M827.54 689.328L839.36 719.678V725.198L824.5 689.328H827.54Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M810.68 745.641L822.9 778.251H820.24L810.68 752.561V745.641Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M843.08 689.328L871.23 766.388V778.248H868.62L843.08 711.058V689.328Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M843.08 689.328H845.63L871.23 760.708V766.388L843.08 689.328Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M847.62 689.328L871.23 755.128V757.018L846.95 689.328H847.62Z",
    fill: "#E4E4ED"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M849.86 689.328L871.23 748.608V753.618L848.17 689.328H849.86Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M848.17 689.328L871.23 753.618V755.128L847.62 689.328H848.17Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M862.36 689.328L871.23 712.748V719.678L859.63 689.328H862.36Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M859.63 689.328L871.23 719.678V725.198L856.63 689.328H859.63Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M843.08 745.641L855.07 778.251H852.46L843.08 752.561V745.641Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M870.17 778.25H871.23V689.33H870.17V778.25Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M838.3 778.25H839.36V689.33H838.3V778.25Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 815.789H810.68V917.56H882.58V815.789Z",
    fill: "#F4F4F4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 815.789H871.66V917.56H882.58V815.789Z",
    fill: "#1C1C1C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M882.58 815.789H871.66V917.56H882.58V815.789Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M882.58 815.789H871.66V917.56H882.58V815.789Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M810.68 917.57H875.48V815.8H810.68V917.57Z",
    fill: "#3F4249"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M843.08 910.65H871.23V821.728H843.08V910.65Z",
    fill: "#F4F4F4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M843.08 910.65H871.23V821.728H843.08V910.65Z",
    fill: "#1C1C1C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M810.679 910.65H839.36V821.728H810.679V910.65Z",
    fill: "#F4F4F4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M810.679 910.65H839.36V821.728H810.679V910.65Z",
    fill: "#1C1C1C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M810.68 821.719L839.36 898.79V910.65H836.71L810.68 843.459V821.719Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M810.68 821.719H813.28L839.36 893.1V898.79L810.68 821.719Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M815.309 821.719L839.36 887.529V889.42L814.619 821.719H815.309Z",
    fill: "#E4E4ED"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M817.589 821.719L839.36 880.999V886.019L815.859 821.719H817.589Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M815.861 821.719L839.36 886.019V887.529L815.311 821.719H815.861Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M830.33 821.719L839.36 845.149V852.079L827.54 821.719H830.33Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M827.54 821.719L839.36 852.079V857.599L824.5 821.719H827.54Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M810.68 878.039L822.9 910.65H820.24L810.68 884.959V878.039Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M843.08 821.719L871.23 898.79V910.65H868.62L843.08 843.459V821.719Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M843.08 821.719H845.63L871.23 893.1V898.79L843.08 821.719Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M847.62 821.719L871.23 887.529V889.42L846.95 821.719H847.62Z",
    fill: "#E4E4ED"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M849.86 821.719L871.23 880.999V886.019L848.17 821.719H849.86Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M848.17 821.719L871.23 886.019V887.529L847.62 821.719H848.17Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M862.36 821.719L871.23 845.149V852.079L859.63 821.719H862.36Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M859.63 821.719L871.23 852.079V857.599L856.63 821.719H859.63Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M843.08 878.039L855.07 910.65H852.46L843.08 884.959V878.039Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M870.17 910.65H871.23V821.728H870.17V910.65Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M838.3 910.65H839.36V821.728H838.3V910.65Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M977.56 815.789H905.66V917.56H977.56V815.789Z",
    fill: "#F4F4F4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M977.56 815.789H966.64V917.56H977.56V815.789Z",
    fill: "#1C1C1C"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M977.56 815.789H966.64V917.56H977.56V815.789Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M977.56 815.789H966.64V917.56H977.56V815.789Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M905.65 917.57H970.45V815.8H905.65V917.57Z",
    fill: "#3F4249"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M938.05 910.65H966.2V821.728H938.05V910.65Z",
    fill: "#F4F4F4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M938.05 910.65H966.2V821.728H938.05V910.65Z",
    fill: "#1C1C1C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M905.65 910.65H934.33V821.728H905.65V910.65Z",
    fill: "#F4F4F4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M905.65 910.65H934.33V821.728H905.65V910.65Z",
    fill: "#1C1C1C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M905.66 821.719L934.34 898.79V910.65H931.68L905.66 843.459V821.719Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M905.66 821.719H908.25L934.34 893.1V898.79L905.66 821.719Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M910.29 821.719L934.34 887.529V889.42L909.6 821.719H910.29Z",
    fill: "#E4E4ED"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M912.56 821.719L934.34 880.999V886.019L910.84 821.719H912.56Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M910.84 821.719L934.34 886.019V887.529L910.29 821.719H910.84Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M925.3 821.719L934.34 845.149V852.079L922.52 821.719H925.3Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M922.52 821.719L934.34 852.079V857.599L919.48 821.719H922.52Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M905.66 878.039L917.87 910.65H915.22L905.66 884.959V878.039Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M938.06 821.719L966.2 898.79V910.65H963.6L938.06 843.459V821.719Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M938.06 821.719H940.6L966.2 893.1V898.79L938.06 821.719Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M942.6 821.719L966.2 887.529V889.42L941.92 821.719H942.6Z",
    fill: "#E4E4ED"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M944.83 821.719L966.2 880.999V886.019L943.14 821.719H944.83Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M943.14 821.719L966.2 886.019V887.529L942.6 821.719H943.14Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M957.34 821.719L966.2 845.149V852.079L954.6 821.719H957.34Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M954.6 821.719L966.2 852.079V857.599L951.61 821.719H954.6Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M938.06 878.039L950.05 910.65H947.44L938.06 884.959V878.039Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M965.15 910.65H966.21V821.728H965.15V910.65Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M933.27 910.65H934.33V821.728H933.27V910.65Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M470.721 375.129V964H780.501V375.129H470.721ZM613.631 520.369H497.351V418.599H613.631V520.369ZM751.211 652.769H634.931V550.999H751.211V652.769ZM751.211 520.369H634.931V418.599H751.211V520.369Z",
    fill: "#1A84EE"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M613.63 683.398H497.35V785.168H613.63V683.398Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M508.89 683.398H497.35V785.168H508.89V683.398Z",
    fill: "#1C1C1C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M508.89 683.398H497.35V785.168H508.89V683.398Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M613.63 683.398H505.34V785.168H613.63V683.398Z",
    fill: "#3F4249"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M559.479 689.32H512.439V778.24H559.479V689.32Z",
    fill: "#F4F4F4"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M559.479 689.32H512.439V778.24H559.479V689.32Z",
    fill: "#1C1C1C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M613.629 689.32H565.699V778.24H613.629V689.32Z",
    fill: "#F4F4F4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M613.629 689.32H565.699V778.24H613.629V689.32Z",
    fill: "#1C1C1C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M613.629 689.328L565.699 766.388V778.248H570.129L613.629 706.118V689.328Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M613.629 689.328H609.289L565.699 760.708V766.388L613.629 689.328Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M605.889 689.328L565.699 755.128V757.018L607.039 689.328H605.889Z",
    fill: "#E4E4ED"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M602.089 689.328L565.699 748.608V753.618L604.969 689.328H602.089Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M604.969 689.328L565.699 753.618V755.128L605.889 689.328H604.969Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M580.789 689.328L565.699 712.748V719.678L585.449 689.328H580.789Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M585.449 689.328L565.699 719.678V725.198L589.039 689.328H585.449Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M613.631 745.641L593.211 778.251H597.651L613.631 752.561V745.641Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M559.479 689.328L512.439 766.388V778.248H516.789L559.479 706.118V689.328Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M559.479 689.328H555.229L512.439 760.708V766.388L559.479 689.328Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M551.889 689.328L512.439 755.128V757.018L553.019 689.328H551.889Z",
    fill: "#E4E4ED"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M548.159 689.328L512.439 748.608V753.618L550.979 689.328H548.159Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M550.979 689.328L512.439 753.618V755.128L551.889 689.328H550.979Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M527.259 689.328L512.439 712.748V719.678L531.829 689.328H527.259Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M531.829 689.328L512.439 719.678V725.198L535.349 689.328H531.829Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M559.479 745.641L539.449 778.251H543.799L559.479 752.561V745.641Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M514.219 689.32H512.439V778.24H514.219V689.32Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M567.479 689.32H565.699V778.24H567.479V689.32Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M751.21 683.398H634.93V785.168H751.21V683.398Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M646.47 683.398H634.93V785.168H646.47V683.398Z",
    fill: "#1C1C1C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M646.47 683.398H634.93V785.168H646.47V683.398Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M751.21 683.398H642.92V785.168H751.21V683.398Z",
    fill: "#3F4249"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M697.06 689.32H650.02V778.24H697.06V689.32Z",
    fill: "#F4F4F4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M697.06 689.32H650.02V778.24H697.06V689.32Z",
    fill: "#1C1C1C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M751.209 689.32H703.279V778.24H751.209V689.32Z",
    fill: "#F4F4F4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M751.209 689.32H703.279V778.24H751.209V689.32Z",
    fill: "#1C1C1C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M751.209 689.328L703.279 766.388V778.248H707.719L751.209 706.118V689.328Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M751.209 689.328H746.869L703.279 760.708V766.388L751.209 689.328Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M743.469 689.328L703.279 755.128V757.018L744.619 689.328H743.469Z",
    fill: "#E4E4ED"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M739.669 689.328L703.279 748.608V753.618L742.549 689.328H739.669Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M742.549 689.328L703.279 753.618V755.128L743.469 689.328H742.549Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M718.379 689.328L703.279 712.748V719.678L723.029 689.328H718.379Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M723.029 689.328L703.279 719.678V725.198L726.629 689.328H723.029Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M751.209 745.641L730.789 778.251H735.229L751.209 752.561V745.641Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M697.06 689.328L650.02 766.388V778.248H654.38L697.06 706.118V689.328Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M697.06 689.328H692.81L650.02 760.708V766.388L697.06 689.328Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M689.469 689.328L650.02 755.128V757.018L690.599 689.328H689.469Z",
    fill: "#E4E4ED"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M685.74 689.328L650.02 748.608V753.618L688.56 689.328H685.74Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M688.56 689.328L650.02 753.618V755.128L689.469 689.328H688.56Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M664.84 689.328L650.02 712.748V719.678L669.409 689.328H664.84Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M669.409 689.328L650.02 719.678V725.198L672.93 689.328H669.409Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M697.059 745.641L677.029 778.251H681.379L697.059 752.561V745.641Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M651.799 689.32H650.02V778.24H651.799V689.32Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M705.059 689.32H703.279V778.24H705.059V689.32Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M613.63 815.789H497.35V917.56H613.63V815.789Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M508.89 815.789H497.35V917.56H508.89V815.789Z",
    fill: "#1C1C1C"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M508.89 815.789H497.35V917.56H508.89V815.789Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M613.63 815.789H505.34V917.56H613.63V815.789Z",
    fill: "#3F4249"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M559.479 821.719H512.439V910.64H559.479V821.719Z",
    fill: "#F4F4F4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M559.479 821.719H512.439V910.64H559.479V821.719Z",
    fill: "#1C1C1C"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M613.629 821.719H565.699V910.64H613.629V821.719Z",
    fill: "#F4F4F4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M613.629 821.719H565.699V910.64H613.629V821.719Z",
    fill: "#1C1C1C"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M613.629 821.719L565.699 898.79V910.65H570.129L613.629 838.519V821.719Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M613.629 821.719H609.289L565.699 893.1V898.79L613.629 821.719Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M605.889 821.719L565.699 887.529V889.42L607.039 821.719H605.889Z",
    fill: "#E4E4ED"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M602.089 821.719L565.699 880.999V886.019L604.969 821.719H602.089Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M604.969 821.719L565.699 886.019V887.529L605.889 821.719H604.969Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M580.789 821.719L565.699 845.149V852.079L585.449 821.719H580.789Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M585.449 821.719L565.699 852.079V857.599L589.039 821.719H585.449Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M613.631 878.039L593.211 910.65H597.651L613.631 884.959V878.039Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M559.479 821.719L512.439 898.79V910.65H516.789L559.479 838.519V821.719Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M559.479 821.719H555.229L512.439 893.1V898.79L559.479 821.719Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M551.889 821.719L512.439 887.529V889.42L553.019 821.719H551.889Z",
    fill: "#E4E4ED"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M548.159 821.719L512.439 880.999V886.019L550.979 821.719H548.159Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M550.979 821.719L512.439 886.019V887.529L551.889 821.719H550.979Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M527.259 821.719L512.439 845.149V852.079L531.829 821.719H527.259Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M531.829 821.719L512.439 852.079V857.599L535.349 821.719H531.829Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M559.479 878.039L539.449 910.65H543.799L559.479 884.959V878.039Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M514.219 821.719H512.439V910.64H514.219V821.719Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M567.479 821.719H565.699V910.64H567.479V821.719Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M751.21 815.789H634.93V917.56H751.21V815.789Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M646.47 815.789H634.93V917.56H646.47V815.789Z",
    fill: "#1C1C1C"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M646.47 815.789H634.93V917.56H646.47V815.789Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M751.21 815.789H642.92V917.56H751.21V815.789Z",
    fill: "#3F4249"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M697.06 821.719H650.02V910.64H697.06V821.719Z",
    fill: "#F4F4F4"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M697.06 821.719H650.02V910.64H697.06V821.719Z",
    fill: "#1C1C1C"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M751.209 821.719H703.279V910.64H751.209V821.719Z",
    fill: "#F4F4F4"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M751.209 821.719H703.279V910.64H751.209V821.719Z",
    fill: "#1C1C1C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M751.209 821.719L703.279 898.79V910.65H707.719L751.209 838.519V821.719Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M751.209 821.719H746.869L703.279 893.1V898.79L751.209 821.719Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M743.469 821.719L703.279 887.529V889.42L744.619 821.719H743.469Z",
    fill: "#E4E4ED"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M739.669 821.719L703.279 880.999V886.019L742.549 821.719H739.669Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M742.549 821.719L703.279 886.019V887.529L743.469 821.719H742.549Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M718.379 821.719L703.279 845.149V852.079L723.029 821.719H718.379Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M723.029 821.719L703.279 852.079V857.599L726.629 821.719H723.029Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M751.209 878.039L730.789 910.65H735.229L751.209 884.959V878.039Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M697.06 821.719L650.02 898.79V910.65H654.38L697.06 838.519V821.719Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M697.06 821.719H692.81L650.02 893.1V898.79L697.06 821.719Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M689.469 821.719L650.02 887.529V889.42L690.599 821.719H689.469Z",
    fill: "#E4E4ED"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M685.74 821.719L650.02 880.999V886.019L688.56 821.719H685.74Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M688.56 821.719L650.02 886.019V887.529L689.469 821.719H688.56Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M664.84 821.719L650.02 845.149V852.079L669.409 821.719H664.84Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M669.409 821.719L650.02 852.079V857.599L672.93 821.719H669.409Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M697.059 878.039L677.029 910.65H681.379L697.059 884.959V878.039Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M651.799 821.719H650.02V910.64H651.799V821.719Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M705.059 821.719H703.279V910.64H705.059V821.719Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M508.89 418.602H497.35V520.372H508.89V418.602Z",
    fill: "#1C1C1C"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M613.63 551H497.35V652.77H613.63V551Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M508.89 551H497.35V652.77H508.89V551Z",
    fill: "#1C1C1C"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M508.89 551H497.35V652.77H508.89V551Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M613.63 551H505.34V652.77H613.63V551Z",
    fill: "#3F4249"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M559.479 556.93H512.439V645.85H559.479V556.93Z",
    fill: "#F4F4F4"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M559.479 556.93H512.439V645.85H559.479V556.93Z",
    fill: "#1C1C1C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M613.629 556.93H565.699V645.85H613.629V556.93Z",
    fill: "#F4F4F4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M613.629 556.93H565.699V645.85H613.629V556.93Z",
    fill: "#1C1C1C"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M613.629 556.93L565.699 634V645.85H570.129L613.629 573.72V556.93Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M613.629 556.93H609.289L565.699 628.31V634L613.629 556.93Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M605.889 556.93L565.699 622.74V624.63L607.039 556.93H605.889Z",
    fill: "#E4E4ED"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M602.089 556.93L565.699 616.21V621.23L604.969 556.93H602.089Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M604.969 556.93L565.699 621.23V622.74L605.889 556.93H604.969Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M580.789 556.93L565.699 580.35V587.29L585.449 556.93H580.789Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M585.449 556.93L565.699 587.29V592.81L589.039 556.93H585.449Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M613.631 613.25L593.211 645.85H597.651L613.631 620.16V613.25Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M559.479 556.93L512.439 634V645.85H516.789L559.479 573.72V556.93Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M559.479 556.93H555.229L512.439 628.31V634L559.479 556.93Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M551.889 556.93L512.439 622.74V624.63L553.019 556.93H551.889Z",
    fill: "#E4E4ED"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M548.159 556.93L512.439 616.21V621.23L550.979 556.93H548.159Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M550.979 556.93L512.439 621.23V622.74L551.889 556.93H550.979Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M527.259 556.93L512.439 580.35V587.29L531.829 556.93H527.259Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M531.829 556.93L512.439 587.29V592.81L535.349 556.93H531.829Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M559.479 613.25L539.449 645.85H543.799L559.479 620.16V613.25Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M514.219 556.93H512.439V645.85H514.219V556.93Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M567.479 556.93H565.699V645.85H567.479V556.93Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M646.47 551H634.93V652.77H646.47V551Z",
    fill: "#1C1C1C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M646.47 418.602H634.93V520.372H646.47V418.602Z",
    fill: "#1C1C1C"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M508.89 418.602H497.35V520.372H508.89V418.602Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M646.47 551H634.93V652.77H646.47V551Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M646.47 418.602H634.93V520.372H646.47V418.602Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 418.602H871.66V520.372H882.58V418.602Z",
    fill: "#1C1C1C"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M882.58 418.602H871.66V520.372H882.58V418.602Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M882.58 418.602H871.66V520.372H882.58V418.602Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M977.56 551H966.64V652.77H977.56V551Z",
    fill: "#1C1C1C"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M977.56 551H966.64V652.77H977.56V551Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M977.56 551H966.64V652.77H977.56V551Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 551H810.68V652.77H882.58V551Z",
    fill: "#F4F4F4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M882.58 551H871.66V652.77H882.58V551Z",
    fill: "#1C1C1C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M882.58 551H871.66V652.77H882.58V551Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M882.58 551H871.66V652.77H882.58V551Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M810.68 652.77H875.48V551H810.68V652.77Z",
    fill: "#3F4249"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M843.08 645.852H871.23V556.932H843.08V645.852Z",
    fill: "#F4F4F4"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M843.08 645.852H871.23V556.932H843.08V645.852Z",
    fill: "#1C1C1C"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M810.679 645.852H839.36V556.932H810.679V645.852Z",
    fill: "#F4F4F4"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M810.679 645.852H839.36V556.932H810.679V645.852Z",
    fill: "#1C1C1C"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M810.68 556.93L839.36 634V645.85H836.71L810.68 578.66V556.93Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M810.68 556.93H813.28L839.36 628.31V634L810.68 556.93Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M815.309 556.93L839.36 622.74V624.63L814.619 556.93H815.309Z",
    fill: "#E4E4ED"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M817.589 556.93L839.36 616.21V621.23L815.859 556.93H817.589Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M815.861 556.93L839.36 621.23V622.74L815.311 556.93H815.861Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M830.33 556.93L839.36 580.35V587.29L827.54 556.93H830.33Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M827.54 556.93L839.36 587.29V592.81L824.5 556.93H827.54Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M810.68 613.25L822.9 645.85H820.24L810.68 620.16V613.25Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M843.08 556.93L871.23 634V645.85H868.62L843.08 578.66V556.93Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M843.08 556.93H845.63L871.23 628.31V634L843.08 556.93Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M847.62 556.93L871.23 622.74V624.63L846.95 556.93H847.62Z",
    fill: "#E4E4ED"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M849.86 556.93L871.23 616.21V621.23L848.17 556.93H849.86Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M848.17 556.93L871.23 621.23V622.74L847.62 556.93H848.17Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M862.36 556.93L871.23 580.35V587.29L859.63 556.93H862.36Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M859.63 556.93L871.23 587.29V592.81L856.63 556.93H859.63Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M843.08 613.25L855.07 645.85H852.46L843.08 620.16V613.25Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M870.17 645.852H871.23V556.932H870.17V645.852Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M838.3 645.852H839.36V556.932H838.3V645.852Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M977.56 418.602H966.64V520.372H977.56V418.602Z",
    fill: "#1C1C1C"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M977.56 418.602H966.64V520.372H977.56V418.602Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M977.56 418.602H966.64V520.372H977.56V418.602Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M773.379 747.072V639.862H780.129V627.302H773.379V502.922H761.289V627.302H665.839V618.302H654.909V551.152H665.839V520.422H653.749V627.302H556.519V520.422H544.429V627.302H469.269V639.862H544.429V747.072H470.169V759.632H544.429V867.752H460.189V880.312H544.429V964H556.519V880.312H653.749V964H665.839V880.312H761.289V963.74H773.379V759.632H780.999V747.072H773.379ZM653.749 867.752H556.519V759.632H653.749V867.752ZM653.749 747.072H556.519V639.862H653.749V747.072ZM761.289 867.752H665.839V759.632H761.289V867.752ZM761.289 747.072H665.839V652.782H654.909V632.782H746.549V639.782H761.289V747.072Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M764.361 503.059H751.801V964H764.361V503.059Z",
    fill: "#61656D"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M655.47 503.059H642.91V964H655.47V503.059Z",
    fill: "#61656D"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M545.679 503.059H533.119V964H545.679V503.059Z",
    fill: "#61656D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M436.8 503.059H424.24V964H436.8V503.059Z",
    fill: "#61656D"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M746.3 503.059V618.299H647.4V503.059H637.2V618.299H538.3V503.059H528.1V618.299H429.2V503.059H419V964H429.2V874.169H528.1V964H538.3V874.169H637.2V964H647.4V874.169H746.3V964H756.51V503.059H746.3ZM746.3 632.819V738.999H647.4V632.819H746.3ZM637.2 632.819V738.999H538.3V632.819H637.2ZM528.1 632.819V738.999H429.2V632.819H528.1ZM429.2 859.649V753.489H528.1V859.649H429.2ZM538.3 859.649V753.489H637.2V859.649H538.3ZM647.4 859.649V753.489H746.3V859.649H647.4Z",
    fill: "#180C05"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M895.14 502.961H882.58V963.9H895.14V502.961Z",
    fill: "#61656D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M895.14 502.961H882.58V963.9H895.14V502.961Z",
    fill: "black"
  }))), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.43 502.961H1016.87V963.9H1029.43V502.961Z",
    fill: "#61656D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1029.43 502.961H1016.87V963.9H1029.43V502.961Z",
    fill: "black"
  }))), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.23 503.059V618.299H901.83V503.059H891.07V618.299H757.73V632.819H891.07V738.069H757.73V752.589H891.07V857.839H757.73V872.359H891.07V964H901.83V872.359H1025.23V964H1036V503.059H1025.23ZM901.83 632.819H1025.23V738.069H901.83V632.819ZM901.83 857.819V752.589H1025.23V857.839L901.83 857.819Z",
    fill: "#61656D"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M878.51 908.38H877.28C859.28 908.73 859.28 964.08 877.28 964.43H1076.39V908.36L878.51 908.38Z",
    fill: "#1C1C1C"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M878.51 908.38H877.28C859.28 908.73 859.28 964.08 877.28 964.43H1076.39V908.36L878.51 908.38Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M868 936.27H866.7C865.72 936.25 864.75 936.08 863.83 935.75C863.69 949.9 868.18 964.28 877.32 964.45H1076.43V936.27H868Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.22 908.38H1077.16C1058.94 908.38 1058.94 964.45 1077.16 964.45H1078.22C1096.44 964.45 1096.44 908.38 1078.22 908.38Z",
    fill: "#1C1C1C"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1078.22 908.38H1077.16C1058.94 908.38 1058.94 964.45 1077.16 964.45H1078.22C1096.44 964.45 1096.44 908.38 1078.22 908.38Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.13 912.13H1077.25C1062.11 912.13 1062.11 960.7 1077.25 960.7H1078.13C1093.27 960.7 1093.27 912.13 1078.13 912.13Z",
    fill: "#1C1C1C"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1078.13 912.13H1077.25C1062.11 912.13 1062.11 960.7 1077.25 960.7H1078.13C1093.27 960.7 1093.27 912.13 1078.13 912.13Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1070.38 940C1076.32 935.76 1082.51 931.87 1088.91 928.36C1087.59 919.42 1084 912.13 1078.13 912.13H1077.25C1068.25 912.13 1064.64 929.13 1066.25 943.01C1067.62 942 1069 941 1070.38 940Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M938.75 913.11C938.34 913.57 938.07 914.14 937.97 914.75C937.87 915.36 937.95 915.98 938.2 916.55C938.46 917.11 938.86 917.59 939.38 917.93C939.9 918.27 940.5 918.45 941.12 918.45H1029.29C1029.66 918.45 1030.05 918.45 1030.43 918.45C1034.43 918.13 1034.11 912.07 1030.08 912.07H941.16C940.71 912.06 940.26 912.15 939.84 912.33C939.43 912.51 939.06 912.78 938.75 913.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M911.41 918.49C911.91 917.94 912.23 917.25 912.35 916.51C912.47 915.78 912.37 915.02 912.07 914.34C911.76 913.66 911.27 913.08 910.65 912.68C910.02 912.27 909.29 912.05 908.55 912.05H887.55C887.17 912.05 886.79 912.05 886.41 912.1C882.41 912.41 882.72 918.48 886.76 918.48L911.41 918.49Z",
    fill: "white"
  }))), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M962.34 908.42C962.08 908.41 961.83 908.41 961.57 908.42H960.51C942.29 908.42 942.29 964.49 960.51 964.49H961.57C961.83 964.49 962.09 964.49 962.34 964.49C945.15 962.88 945.15 910 962.34 908.42Z",
    fill: "#3F4249"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M862 858H860.77C842.77 858.35 842.77 913.71 860.77 914.06H1059.88V858H862Z",
    fill: "#1C1C1C"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M862 858H860.77C842.77 858.35 842.77 913.71 860.77 914.06H1059.88V858H862Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1054.65 862.47L1052.08 883.47H853C850.96 883.418 849.01 882.65 847.48 881.3C846.34 896.61 850.78 913.86 860.8 914.06H1059.91V858L1054.65 862.47Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.71 858H1060.65C1042.43 858 1042.43 914.08 1060.65 914.08H1061.71C1079.93 914.08 1079.93 858 1061.71 858Z",
    fill: "#1C1C1C"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M922.39 862.459C921.98 862.92 921.71 863.491 921.61 864.102C921.52 864.713 921.6 865.339 921.85 865.904C922.1 866.469 922.51 866.949 923.03 867.288C923.55 867.626 924.15 867.807 924.77 867.809H1012.94C1013.31 867.809 1013.69 867.809 1014.08 867.759C1018.08 867.439 1017.76 861.379 1013.72 861.379H924.8C924.34 861.375 923.89 861.469 923.48 861.655C923.06 861.842 922.69 862.116 922.39 862.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M895.05 867.838C895.55 867.286 895.88 866.599 896 865.862C896.12 865.124 896.02 864.368 895.72 863.686C895.42 863.003 894.92 862.424 894.3 862.017C893.67 861.611 892.94 861.396 892.19 861.398H871.19C870.81 861.398 870.43 861.398 870.05 861.448C866.05 861.768 866.36 867.838 870.4 867.838H895.05Z",
    fill: "white"
  }))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1061.71 858H1060.65C1042.43 858 1042.43 914.08 1060.65 914.08H1061.71C1079.93 914.08 1079.93 858 1061.71 858Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.62 861.75H1060.74C1045.6 861.75 1045.6 910.32 1060.74 910.32H1061.62C1076.76 910.32 1076.76 861.75 1061.62 861.75Z",
    fill: "#1C1C1C"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1061.62 861.75H1060.74C1045.6 861.75 1045.6 910.32 1060.74 910.32H1061.62C1076.76 910.32 1076.76 861.75 1061.62 861.75Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1071.94 875.41C1070.35 867.69 1066.94 861.75 1061.62 861.75H1060.74C1052.28 861.75 1048.55 876.92 1049.54 890.31L1071.94 875.41Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M946 858C945.74 857.984 945.49 857.984 945.23 858H944.17C925.95 858 925.95 914.08 944.17 914.08H945.23C945.49 914.08 945.75 914.08 946 914.08C928.84 912.5 928.84 859.57 946 858Z",
    fill: "#3F4249"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M850 908.38H848.77C830.77 908.73 830.77 964.08 848.77 964.43H1047.88V908.36L850 908.38Z",
    fill: "#1C1C1C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M850 908.38H848.77C830.77 908.73 830.77 964.08 848.77 964.43H1047.88V908.36L850 908.38Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M839.46 936.27H838.16C837.18 936.25 836.21 936.08 835.29 935.75C835.14 949.9 839.63 964.28 848.77 964.45H1047.88V936.27H839.46Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.71 908.38H1048.65C1030.44 908.38 1030.44 964.45 1048.65 964.45H1049.71C1067.93 964.45 1067.93 908.38 1049.71 908.38Z",
    fill: "#1C1C1C"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1049.71 908.38H1048.65C1030.44 908.38 1030.44 964.45 1048.65 964.45H1049.71C1067.93 964.45 1067.93 908.38 1049.71 908.38Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.62 912.13H1048.74C1033.6 912.13 1033.6 960.7 1048.74 960.7H1049.62C1064.76 960.7 1064.76 912.13 1049.62 912.13Z",
    fill: "#1C1C1C"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1049.62 912.13H1048.74C1033.6 912.13 1033.6 960.7 1048.74 960.7H1049.62C1064.76 960.7 1064.76 912.13 1049.62 912.13Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1041.87 940C1047.81 935.76 1054 931.87 1060.4 928.36C1059.08 919.42 1055.49 912.13 1049.62 912.13H1048.74C1039.74 912.13 1036.13 929.13 1037.74 943.01C1039.12 942 1040.48 941 1041.87 940Z",
    fill: "black"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M910.24 913.11C909.83 913.57 909.56 914.14 909.46 914.75C909.36 915.36 909.45 915.99 909.7 916.55C909.95 917.12 910.36 917.6 910.88 917.93C911.4 918.27 912 918.45 912.62 918.45H1000.78C1001.16 918.45 1001.54 918.45 1001.92 918.45C1005.92 918.13 1005.61 912.07 1001.57 912.07H912.65C912.2 912.06 911.75 912.15 911.33 912.33C910.92 912.51 910.55 912.78 910.24 913.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M882.91 918.49C883.41 917.94 883.74 917.25 883.85 916.51C883.97 915.78 883.87 915.02 883.57 914.34C883.26 913.66 882.77 913.08 882.14 912.67C881.52 912.27 880.79 912.05 880.04 912.05H859.04C858.67 912.05 858.29 912.05 857.9 912.1C853.9 912.41 854.22 918.48 858.26 918.48L882.91 918.49Z",
    fill: "white"
  }))), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M933.83 908.42C933.58 908.41 933.32 908.41 933.07 908.42H932C913.78 908.42 913.78 964.49 932 964.49H933.06C933.32 964.49 933.57 964.49 933.82 964.49C916.64 962.88 916.64 910 933.83 908.42Z",
    fill: "#3F4249"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M860.28 964H587.789C587.789 964 650.579 857.321 733.489 829.891C733.489 829.891 798.099 877.441 860.28 964Z",
    fill: "#B2B6BB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M736.149 831.922C819.149 956.99 611.149 953.28 594.409 953.56C590.099 960.08 587.789 964 587.789 964H860.28C805.519 887.762 748.879 841.802 736.149 831.922Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M920 964H775.551C775.551 964 815.631 920.84 861.33 909.75C861.33 909.75 892.56 929 920 964Z",
    fill: "#B2B6BB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M861.33 909.75L860.76 909.9C869.42 922.55 868.76 938.49 858.15 947.54C839.72 963.24 796.991 963.03 780.351 959.16C777.261 962.16 775.551 964 775.551 964H920C892.56 929 861.33 909.75 861.33 909.75Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M154.699 957C155.009 959.11 155.449 962 153.119 963.18C150.279 964.54 148.469 961.45 148.119 959.06L132.119 851.161C131.189 845.261 131.919 840.242 133.739 839.962C135.559 839.682 137.799 844.221 138.739 850.121C138.689 850.081 154.539 955.93 154.699 957Z",
    fill: "#61656D"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M138.469 848.849C137.469 843.559 135.399 839.649 133.709 839.919C132.019 840.189 131.249 844.679 131.949 850.149C134.119 849.689 136.299 849.259 138.469 848.849Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M118.989 844.978L97.949 818.928L109.989 787.688L143.059 782.488L164.099 808.538L152.059 839.778L118.989 844.978Z",
    fill: "#1C1C1C"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M153.07 841L118.41 846.45L96.41 819.16L109 786.45L143.63 781L165.68 808.29L153.07 841ZM119.56 843.46L151.06 838.46L162.51 808.71L142.51 783.92L111.02 788.92L99.56 818.67L119.56 843.46Z",
    fill: "#1C1C1C"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.07 841L118.41 846.45L96.41 819.16L109 786.45L143.63 781L165.68 808.29L153.07 841ZM119.56 843.46L151.06 838.46L162.51 808.71L142.51 783.92L111.02 788.92L99.56 818.67L119.56 843.46Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M148.33 808.001L141.33 804.201L140.1 796.301L135.62 796.991L136.32 801.481L129.01 797.481L113.75 813.331L117.02 816.461L118.66 814.761L121.19 831.071L146.62 827.141L144.09 810.821L146.17 811.951L148.33 808.001ZM143.73 825.071L138 826.001L136.54 816.561L127.54 817.951L129 827.391L123.26 828.281L120.87 812.861L129.87 803.491L141.29 809.691L143.73 825.071Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M539.729 458.74L606.309 388.26L605.399 387.39C605.219 387.218 605.007 387.083 604.774 386.994C604.542 386.904 604.294 386.861 604.045 386.868C603.796 386.874 603.55 386.93 603.323 387.032C603.096 387.133 602.89 387.279 602.719 387.46L537.439 456.55L539.729 458.74Z",
    fill: "#21252B"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M305.6 167.5L520.87 258.72H561.87L305.6 165.18V167.5ZM316.28 170.45L554.51 257.45H521.26L316.28 170.45Z",
    fill: "#21252B"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M295.93 165.461V167.191L195.55 255.121L194.59 254.251L295.93 165.461Z",
    fill: "#21252B"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M302.041 256.509L315.131 239.739L313.941 238.809L300.131 256.509H302.041Z",
    fill: "#3F4249"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M305.84 256.511L292.55 238.961L291.35 239.881L303.95 256.511H305.84Z",
    fill: "#3F4249"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M311.909 205.09L291.793 236.738L293.067 237.548L313.183 205.9L311.909 205.09Z",
    fill: "#FFCF4A"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M294.807 205.25L293.521 206.043L312.638 237.043L313.923 236.25L294.807 205.25Z",
    fill: "#FFCF4A"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M309.598 171.942L294.105 203.594L295.462 204.258L310.954 172.606L309.598 171.942Z",
    fill: "#FFCF4A"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M296.803 172.09L295.439 172.738L310.186 203.739L311.55 203.091L296.803 172.09Z",
    fill: "#FFCF4A"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M314.621 235.898H291.391V240.038H314.621V235.898Z",
    fill: "#FFCF4A"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M312.341 202.941H293.631V207.081H312.341V202.941Z",
    fill: "#FFCF4A"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M291.9 256.508L297.22 173.658L309.06 173.648L314.49 256.508H316.91L311.39 172.358L311.31 171.238L294.96 171.248L289.48 256.508H291.9Z",
    fill: "#FFCF4A"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M312.59 189.812H293.59C293.51 189.812 293.431 189.796 293.357 189.765C293.283 189.735 293.216 189.69 293.159 189.633C293.102 189.576 293.058 189.509 293.027 189.435C292.996 189.361 292.98 189.282 292.98 189.202V171.132C292.98 168.448 294.047 165.874 295.945 163.976C297.842 162.078 300.416 161.012 303.1 161.012C305.784 161.012 308.359 162.078 310.256 163.976C312.154 165.874 313.22 168.448 313.22 171.132V189.212C313.215 189.374 313.146 189.528 313.028 189.641C312.91 189.753 312.753 189.814 312.59 189.812Z",
    fill: "#FFCF4A"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M309.3 172.049C308.943 173.284 308.229 174.385 307.246 175.214C306.264 176.043 305.058 176.562 303.781 176.705C302.504 176.849 301.213 176.611 300.071 176.021C298.929 175.431 297.988 174.516 297.366 173.391C296.744 172.266 296.47 170.982 296.578 169.701C296.685 168.421 297.17 167.201 297.971 166.195C298.772 165.19 299.853 164.445 301.077 164.054C302.302 163.663 303.614 163.644 304.85 163.999C306.506 164.478 307.905 165.594 308.74 167.103C309.574 168.613 309.775 170.391 309.3 172.049Z",
    fill: "#868A91"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M307.32 171.48C307.073 172.324 306.582 173.076 305.909 173.64C305.235 174.205 304.409 174.557 303.535 174.651C302.661 174.746 301.779 174.579 301 174.171C300.221 173.764 299.58 173.135 299.159 172.363C298.738 171.591 298.556 170.712 298.635 169.837C298.714 168.961 299.052 168.129 299.604 167.445C300.157 166.762 300.9 166.258 301.74 165.997C302.579 165.736 303.477 165.73 304.32 165.98C305.445 166.314 306.393 167.08 306.955 168.111C307.517 169.142 307.648 170.353 307.32 171.48Z",
    fill: "#FFED00"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M303.929 167.219C303.33 167.048 302.694 167.058 302.101 167.248C301.508 167.438 300.985 167.799 300.597 168.287C300.209 168.774 299.975 169.366 299.923 169.986C299.871 170.607 300.005 171.229 300.307 171.774C300.608 172.319 301.065 172.762 301.618 173.047C302.172 173.333 302.798 173.448 303.416 173.378C304.035 173.308 304.619 173.056 305.095 172.654C305.571 172.252 305.917 171.718 306.089 171.119C306.204 170.721 306.239 170.305 306.192 169.893C306.146 169.482 306.018 169.084 305.818 168.721C305.617 168.359 305.347 168.04 305.023 167.782C304.699 167.525 304.327 167.333 303.929 167.219ZM302.279 172.939C301.747 172.786 301.273 172.478 300.917 172.055C300.56 171.632 300.336 171.112 300.275 170.562C300.213 170.012 300.315 169.456 300.569 168.965C300.823 168.473 301.217 168.068 301.701 167.8C302.186 167.532 302.738 167.413 303.29 167.459C303.841 167.505 304.367 167.714 304.8 168.058C305.233 168.403 305.554 168.868 305.723 169.395C305.892 169.922 305.901 170.487 305.749 171.019C305.648 171.374 305.478 171.704 305.248 171.993C305.019 172.281 304.735 172.521 304.413 172.7C304.09 172.878 303.736 172.991 303.37 173.032C303.004 173.073 302.633 173.042 302.279 172.939Z",
    fill: "#868A91"
  }))), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M313.211 189.201V188.691C313.125 188.759 313.02 188.797 312.911 188.801H293.291C293.173 188.795 293.059 188.757 292.961 188.691V189.191C292.961 189.353 293.025 189.508 293.14 189.623C293.254 189.737 293.409 189.801 293.571 189.801H312.571C312.652 189.804 312.734 189.791 312.81 189.762C312.886 189.733 312.956 189.69 313.015 189.634C313.075 189.578 313.123 189.511 313.156 189.437C313.19 189.363 313.208 189.283 313.211 189.201Z",
    fill: "#868A91"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M289.329 918.69V918.4H290.329L290.599 918.69H292.759L292.499 918.4H317.419L317.129 918.71H325.029V260.102H319.239V278.442L305.839 263.662L319.619 248.922H321.239V244.512H288.109V248.912H290.319L303.649 263.622L289.329 279.002V260.102H283.529V918.69H289.329ZM290.819 913.99L304.759 899.07L318.269 914L290.819 913.99ZM318.819 316.192H290.259L304.759 300.662L318.819 316.192ZM292.519 284.772H317.439L304.779 298.322L292.519 284.772ZM317.439 320.602L304.779 334.152L292.519 320.612L317.439 320.602ZM318.269 351.432H290.819L304.759 336.502L318.269 351.432ZM317.439 355.842L304.779 369.392L292.519 355.852L317.439 355.842ZM318.269 386.672H290.819L304.759 371.752L318.269 386.672ZM317.439 391.082L304.779 404.632L292.519 391.092L317.439 391.082ZM318.269 421.912H290.819L304.759 407.002L318.269 421.912ZM317.439 426.322L304.779 439.872L292.519 426.332L317.439 426.322ZM318.269 457.152H290.819L304.759 442.222L318.269 457.152ZM317.439 461.552L304.779 475.112L292.519 461.572L317.439 461.552ZM318.269 492.382H290.819L304.759 477.452L318.269 492.382ZM317.439 496.792L304.779 510.342L292.519 496.812L317.439 496.792ZM318.269 527.622H290.819L304.759 512.692L318.269 527.622ZM317.439 532.032L304.779 545.582L292.519 532.002L317.439 532.032ZM318.269 562.862H290.819L304.759 548.002L318.269 562.862ZM317.439 567.272L304.779 580.822L292.519 567.282L317.439 567.272ZM318.269 598.102H290.819L304.759 583.182L318.269 598.102ZM317.439 602.512L304.779 616.062L292.519 602.522L317.439 602.512ZM318.269 633.342H290.819L304.759 618.422L318.269 633.342ZM317.439 637.752L304.779 651.302L292.519 637.762L317.439 637.752ZM318.269 668.582H290.819L304.759 653.652L318.269 668.582ZM317.439 672.982L304.779 686.542L292.519 673.002L317.439 672.982ZM318.269 703.812H290.819L304.759 688.882L318.269 703.812ZM315.689 708.222L304.779 719.902L294.209 708.232L315.689 708.222ZM318.819 737.782H290.259L304.759 722.252L318.819 737.782ZM317.439 742.192L304.779 755.742L292.519 742.212L317.439 742.192ZM318.269 773.022H290.819L304.759 758.092L318.269 773.022ZM317.439 777.432L304.779 791.002L292.519 777.472L317.439 777.432ZM318.269 808.262H290.819L304.759 793.332L318.269 808.262ZM317.439 812.672L304.779 826.222L292.519 812.682L317.439 812.672ZM318.269 843.502H290.819L304.759 828.572L318.269 843.502ZM317.439 847.912L304.779 861.462L292.519 847.922L317.439 847.912ZM318.269 878.742H290.819L304.759 863.822L318.269 878.742ZM317.439 883.152L304.779 896.7L292.519 883.162L317.439 883.152ZM319.259 912.67L305.859 897.89L319.259 883.552V912.67ZM319.259 877.432L305.859 862.652L319.259 848.312V877.432ZM319.259 842.192L305.859 827.412L319.259 813.072V842.192ZM319.259 806.962L305.859 792.172L319.259 777.842V806.962ZM319.259 771.722L305.859 756.942L319.259 742.602V771.722ZM319.259 712.092V735.882L305.859 721.092L317.859 708.222H319.229L319.259 712.092ZM319.259 681.702V702.512L305.859 687.732L319.259 673.392V681.702ZM319.259 667.272L305.859 652.492L319.259 638.152V667.272ZM319.259 632.032L305.859 617.252L319.259 602.912V632.032ZM319.259 596.792L305.859 582.002L319.259 567.662V596.792ZM319.259 561.552L305.859 546.772L319.259 532.442V561.552ZM319.259 526.322L305.859 511.542L319.259 497.202V526.322ZM319.259 491.082L305.859 476.302L319.259 462.002V491.082ZM319.259 455.842L305.859 441.062L319.259 426.722V455.842ZM319.259 420.602L305.859 405.822L319.259 391.482V420.602ZM319.259 385.362L305.859 370.582L319.259 356.242V385.362ZM319.259 350.132L305.859 335.342L319.259 321.002V350.132ZM319.259 314.282L305.859 299.502L319.259 285.162V314.282ZM292.519 248.932H317.439L304.779 262.482L292.519 248.932ZM304.759 264.842L318.819 280.352H290.259L304.759 264.842ZM289.329 284.772H290.329L303.659 299.492L289.309 314.862L289.329 284.772ZM289.329 320.622H290.329L303.659 335.332L289.329 350.702V320.622ZM289.329 355.852H290.329L303.659 370.572L289.309 385.942L289.329 355.852ZM289.329 391.092H290.329L303.659 405.802L289.309 421.172L289.329 391.092ZM289.329 426.332H290.329L303.679 441.002L289.329 456.372V426.332ZM289.329 461.572H290.329L303.659 476.282L289.309 491.652L289.329 461.572ZM289.329 496.812H290.329L303.659 511.522L289.309 526.892L289.329 496.812ZM289.329 532.052H290.329L303.659 546.762L289.309 562.132L289.329 532.052ZM289.329 567.282H290.329L303.679 582.002L289.329 597.372V567.282ZM289.329 602.522H290.329L303.659 617.232L289.329 632.602V602.522ZM289.329 637.762H290.329L303.659 652.472L289.309 667.842L289.329 637.762ZM289.329 681.702V673.002H290.329L303.659 687.712L289.309 703.082L289.329 681.702ZM289.329 712.092V708.242H292.049L303.679 721.082L289.329 736.452V712.092ZM289.329 742.212H290.329L303.659 756.922L289.309 772.292L289.329 742.212ZM289.329 777.452H290.329L303.659 792.162L289.309 807.532L289.329 777.452ZM289.329 812.692H290.329L303.659 827.412L289.309 842.782L289.329 812.692ZM289.329 847.922H290.329L303.659 862.642L289.329 878.002V847.922ZM289.329 883.162H290.329L303.659 897.87L289.309 913.24L289.329 883.162Z",
    fill: "#FFCF4A"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M365.857 257.54L364.834 258.637L396.418 288.11L397.442 287.013L365.857 257.54Z",
    fill: "#FFCF4A"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M395.92 257.334L365.004 285.348L366.011 286.459L396.927 258.446L395.92 257.334Z",
    fill: "#FFCF4A"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M398.14 256.41L395.17 256.42L395.19 287.47H398.14V256.41Z",
    fill: "#3F4249"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M332.83 257.563L331.807 258.66L363.396 288.128L364.419 287.031L332.83 257.563Z",
    fill: "#FFCF4A"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M362.885 257.342L331.969 285.355L332.976 286.467L363.892 258.454L362.885 257.342Z",
    fill: "#FFCF4A"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M362.15 256.43L362.166 287.48L366.296 287.478L366.28 256.428L362.15 256.43Z",
    fill: "#FFCF4A"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M299.791 257.536L298.768 258.633L330.352 288.106L331.375 287.01L299.791 257.536Z",
    fill: "#3F4249"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M329.85 257.338L298.934 285.352L299.941 286.463L330.857 258.45L329.85 257.338Z",
    fill: "#3F4249"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M329.117 256.43L329.133 287.48L333.263 287.478L333.247 256.428L329.117 256.43Z",
    fill: "#3F4249"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M266.75 257.544L265.727 258.641L297.311 288.114L298.334 287.017L266.75 257.544Z",
    fill: "#FFCF4A"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M296.815 257.334L265.898 285.348L266.906 286.459L297.822 258.446L296.815 257.334Z",
    fill: "#FFCF4A"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M296.33 256.63V287.68H300.46V256.63H296.33Z",
    fill: "#3F4249"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M233.725 257.54L232.701 258.637L264.285 288.11L265.309 287.013L233.725 257.54Z",
    fill: "#FFCF4A"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M263.772 257.338L232.855 285.352L233.863 286.463L264.779 258.45L263.772 257.338Z",
    fill: "#FFCF4A"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M263.279 256.641V287.691H267.409V256.641H263.279Z",
    fill: "#FFCF4A"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M200.684 257.548L199.66 258.645L231.244 288.118L232.268 287.021L200.684 257.548Z",
    fill: "#FFCF4A"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M231.75 258.462L200.83 286.472L199.82 285.362L210.33 275.832L230.74 257.352L231.75 258.462Z",
    fill: "#FFCF4A"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M230.009 256.43L230.025 287.48L234.155 287.478L234.139 256.428L230.009 256.43Z",
    fill: "#FFCF4A"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M167.656 257.567L166.633 258.664L198.222 288.132L199.245 287.035L167.656 257.567Z",
    fill: "#3F4249"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M197.701 257.342L166.785 285.355L167.792 286.467L198.708 258.454L197.701 257.342Z",
    fill: "#3F4249"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M197.17 256.63V287.68H201.3V256.63H197.17Z",
    fill: "#3F4249"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M630.131 257.524L629.107 258.621L660.692 288.094L661.715 286.998L630.131 257.524Z",
    fill: "#FFCF4A"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M660.209 257.334L629.293 285.348L630.3 286.459L661.216 258.446L660.209 257.334Z",
    fill: "#FFCF4A"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M659.93 256.63V287.68H664.06V256.63H659.93Z",
    fill: "#FFCF4A"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M597.105 257.532L596.082 258.629L627.666 288.102L628.69 287.006L597.105 257.532Z",
    fill: "#FFCF4A"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M627.174 257.342L596.258 285.355L597.265 286.467L628.181 258.454L627.174 257.342Z",
    fill: "#FFCF4A"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M626.451 256.43L626.467 287.48L630.597 287.478L630.581 256.428L626.451 256.43Z",
    fill: "#FFCF4A"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M564.064 257.528L563.041 258.625L594.625 288.098L595.649 287.002L564.064 257.528Z",
    fill: "#FFCF4A"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M594.139 257.33L563.223 285.344L564.23 286.455L595.146 258.442L594.139 257.33Z",
    fill: "#FFCF4A"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M593.408 256.43L593.424 287.48L597.554 287.478L597.538 256.428L593.408 256.43Z",
    fill: "#FFCF4A"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M531.039 257.528L530.016 258.625L561.6 288.098L562.623 287.002L531.039 257.528Z",
    fill: "#FFCF4A"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M561.104 257.342L530.188 285.355L531.195 286.467L562.111 258.454L561.104 257.342Z",
    fill: "#FFCF4A"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M560.386 256.442L560.402 287.492L564.532 287.49L564.516 256.44L560.386 256.442Z",
    fill: "#FFCF4A"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M498.004 257.555L496.98 258.652L528.57 288.12L529.593 287.023L498.004 257.555Z",
    fill: "#FFCF4A"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M528.061 257.338L497.145 285.352L498.152 286.463L529.068 258.45L528.061 257.338Z",
    fill: "#FFCF4A"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M527.711 256.63V287.68H531.841V256.63H527.711Z",
    fill: "#FFCF4A"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M464.967 257.532L463.943 258.629L495.528 288.102L496.551 287.006L464.967 257.532Z",
    fill: "#FFCF4A"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M495.033 257.338L464.117 285.352L465.124 286.463L496.041 258.45L495.033 257.338Z",
    fill: "#FFCF4A"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M494.66 256.63V287.68H498.79V256.63H494.66Z",
    fill: "#FFCF4A"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M431.932 257.528L430.908 258.625L462.492 288.098L463.516 287.002L431.932 257.528Z",
    fill: "#FFCF4A"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M461.99 257.334L431.074 285.348L432.081 286.459L462.998 258.446L461.99 257.334Z",
    fill: "#FFCF4A"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M461.257 256.43L461.273 287.48L465.403 287.478L465.387 256.428L461.257 256.43Z",
    fill: "#FFCF4A"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M398.9 257.536L397.877 258.633L429.461 288.106L430.485 287.01L398.9 257.536Z",
    fill: "#FFCF4A"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M428.955 257.338L398.039 285.352L399.046 286.463L429.962 258.45L428.955 257.338Z",
    fill: "#FFCF4A"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M428.224 256.442L428.24 287.492L432.37 287.49L432.354 256.44L428.224 256.442Z",
    fill: "#FFCF4A"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M395.193 256.442L395.209 287.492L399.339 287.49L399.323 256.44L395.193 256.442Z",
    fill: "#FFCF4A"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M669.83 255.129C667.842 253.658 665.434 252.862 662.96 252.859H167V258.289H414.95H662.9C665.404 258.297 667.846 259.068 669.9 260.499L707.05 286.349H437.025H167V291.779H708.69C709.555 291.779 710.384 291.436 710.995 290.825C711.607 290.213 711.95 289.384 711.95 288.519V287.999C711.949 287.49 711.829 286.988 711.6 286.533C711.371 286.078 711.039 285.683 710.63 285.379L669.83 255.129Z",
    fill: "#FFCF4A"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M605.01 344.012H602.75V360.902H605.01V344.012Z",
    fill: "#21252B"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M604.53 344.551L575.24 299.521L576.24 298.831L604.45 342.191L628.61 298.441L629.66 299.061L604.53 344.551Z",
    fill: "#21252B"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M571.46 299C571.429 299.185 571.409 299.372 571.4 299.56C571.371 300.175 571.467 300.789 571.682 301.366C571.898 301.942 572.228 302.469 572.653 302.914C573.078 303.36 573.588 303.714 574.154 303.956C574.72 304.198 575.329 304.323 575.945 304.323C576.56 304.323 577.169 304.198 577.735 303.956C578.301 303.714 578.812 303.36 579.236 302.914C579.661 302.469 579.991 301.942 580.207 301.366C580.422 300.789 580.518 300.175 580.489 299.56C580.5 299.373 580.5 299.187 580.489 299H571.46Z",
    fill: "#3F4249"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M573.141 299.199C573.141 299.309 573.141 299.429 573.141 299.549C573.141 300.302 573.44 301.025 573.972 301.557C574.505 302.09 575.227 302.389 575.981 302.389C576.734 302.389 577.456 302.09 577.989 301.557C578.521 301.025 578.821 300.302 578.821 299.549C578.821 299.429 578.821 299.309 578.821 299.199H573.141Z",
    fill: "#868A91"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M623.93 299C623.9 299.185 623.88 299.372 623.87 299.56C623.841 300.175 623.938 300.789 624.153 301.366C624.368 301.942 624.698 302.469 625.123 302.914C625.548 303.36 626.059 303.714 626.625 303.956C627.191 304.198 627.8 304.323 628.415 304.323C629.031 304.323 629.64 304.198 630.206 303.956C630.771 303.714 631.282 303.36 631.707 302.914C632.132 302.469 632.462 301.942 632.677 301.366C632.893 300.789 632.989 300.175 632.96 299.56C632.954 299.373 632.937 299.186 632.91 299H623.93Z",
    fill: "#3F4249"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M625.609 299.199C625.609 299.309 625.609 299.429 625.609 299.549C625.609 300.302 625.909 301.025 626.441 301.557C626.974 302.09 627.696 302.389 628.449 302.389C629.203 302.389 629.925 302.09 630.458 301.557C630.99 301.025 631.289 300.302 631.289 299.549C631.3 299.433 631.3 299.316 631.289 299.199H625.609Z",
    fill: "#868A91"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M603.01 351.659C607.975 351.659 612 347.567 612 342.519C612 337.471 607.975 333.379 603.01 333.379C598.044 333.379 594.02 337.471 594.02 342.519C594.02 347.567 598.044 351.659 603.01 351.659Z",
    fill: "#3F4249"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M639.581 291.469H615.561L620.951 300.719H634.191L639.581 291.469Z",
    fill: "#3F4249"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M586.501 291.469H562.471L567.861 300.719H581.111L586.501 291.469Z",
    fill: "#3F4249"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M597.711 342.52C597.754 343.558 598.101 344.561 598.709 345.403C599.318 346.246 600.16 346.891 601.132 347.258C602.104 347.625 603.163 347.699 604.176 347.469C605.19 347.24 606.114 346.717 606.833 345.967C607.551 345.217 608.034 344.272 608.22 343.25C608.406 342.227 608.288 341.173 607.88 340.217C607.471 339.262 606.791 338.447 605.924 337.875C605.056 337.303 604.04 336.999 603.001 337C602.29 337.013 601.589 337.166 600.938 337.451C600.287 337.736 599.699 338.147 599.207 338.66C598.716 339.173 598.33 339.778 598.074 340.44C597.817 341.103 597.693 341.81 597.711 342.52Z",
    fill: "#868A91"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M602.08 373.85C605.42 376.04 607.17 377.25 607.64 378.46C608.11 379.67 608.08 388.46 602.94 387.57C600.6 387.17 600.52 384.5 600.52 384.5C600.52 383.2 597.52 383.2 597.52 384.5C597.52 384.5 597.2 389.03 603.39 389.03C610.12 389.03 613.79 385.03 613.79 380.85C613.79 374.46 605.73 371.3 605.65 370.41C605.57 369.52 605.65 363.41 605.65 363.41H602.29L602.08 373.85Z",
    fill: "#1C1C1C"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M606.86 362.711H602.24V371.221L606.86 368.131V362.711Z",
    fill: "#1C1C1C"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M602.08 373.85C605.42 376.04 607.17 377.25 607.64 378.46C608.11 379.67 608.08 388.46 602.94 387.57C600.6 387.17 600.52 384.5 600.52 384.5C600.52 383.2 597.52 383.2 597.52 384.5C597.52 384.5 597.2 389.03 603.39 389.03C610.12 389.03 613.79 385.03 613.79 380.85C613.79 374.46 605.73 371.3 605.65 370.41C605.57 369.52 605.65 363.41 605.65 363.41H602.29L602.08 373.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M606.86 362.711H602.24V371.221L606.86 368.131V362.711Z",
    fill: "black"
  }))), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M598.679 342.52C598.716 343.368 599.002 344.186 599.5 344.873C599.998 345.56 600.688 346.085 601.482 346.383C602.276 346.682 603.141 346.74 603.968 346.552C604.795 346.363 605.549 345.935 606.135 345.322C606.721 344.708 607.115 343.936 607.266 343.101C607.417 342.266 607.319 341.405 606.985 340.625C606.651 339.845 606.095 339.18 605.387 338.714C604.678 338.247 603.848 337.999 602.999 338C602.418 338.012 601.845 338.138 601.313 338.372C600.782 338.606 600.301 338.942 599.9 339.362C599.498 339.782 599.184 340.277 598.974 340.819C598.765 341.361 598.665 341.939 598.679 342.52Z",
    fill: "#3F4249"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M600.919 373.85C604.259 376.04 606.009 377.25 606.479 378.46C606.949 379.67 606.909 388.46 601.779 387.57C599.429 387.17 599.349 384.5 599.349 384.5C599.349 383.2 596.299 383.2 596.299 384.5C596.299 384.5 595.989 389.03 602.169 389.03C608.899 389.03 612.579 385.03 612.579 380.85C612.579 374.46 604.519 371.3 604.439 370.41C604.359 369.52 604.439 363.41 604.439 363.41H601.079L600.919 373.85Z",
    fill: "#1C1C1C"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M605.69 362.711H601.08V371.221L605.69 368.131V362.711Z",
    fill: "#1C1C1C"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M600.919 373.85C604.259 376.04 606.009 377.25 606.479 378.46C606.949 379.67 606.909 388.46 601.779 387.57C599.429 387.17 599.349 384.5 599.349 384.5C599.349 383.2 596.299 383.2 596.299 384.5C596.299 384.5 595.989 389.03 602.169 389.03C608.899 389.03 612.579 385.03 612.579 380.85C612.579 374.46 604.519 371.3 604.439 370.41C604.359 369.52 604.439 363.41 604.439 363.41H601.079L600.919 373.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M605.69 362.711H601.08V371.221L605.69 368.131V362.711Z",
    fill: "white"
  }))), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M599.44 362.28C599.467 363.11 599.739 363.914 600.22 364.591C600.701 365.268 601.371 365.788 602.146 366.087C602.921 366.386 603.766 366.45 604.578 366.271C605.389 366.092 606.129 365.679 606.707 365.082C607.285 364.485 607.674 363.732 607.826 362.915C607.978 362.099 607.887 361.256 607.563 360.491C607.239 359.726 606.697 359.073 606.005 358.614C605.312 358.156 604.5 357.911 603.67 357.91C602.53 357.931 601.445 358.403 600.653 359.222C599.86 360.041 599.424 361.14 599.44 362.28Z",
    fill: "#868A91"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M601.469 362.28C601.483 362.714 601.624 363.135 601.876 363.489C602.127 363.843 602.478 364.116 602.883 364.272C603.289 364.428 603.731 364.462 604.155 364.368C604.58 364.274 604.967 364.057 605.268 363.745C605.57 363.432 605.773 363.037 605.852 362.61C605.93 362.183 605.881 361.742 605.71 361.342C605.54 360.942 605.255 360.602 604.892 360.363C604.529 360.125 604.104 359.998 603.669 360C603.375 360.005 603.085 360.068 602.815 360.186C602.545 360.303 602.301 360.473 602.097 360.684C601.893 360.896 601.732 361.146 601.624 361.42C601.517 361.693 601.464 361.986 601.469 362.28Z",
    fill: "#3F4249"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M602.43 362.28C602.438 362.523 602.517 362.759 602.658 362.958C602.799 363.156 602.995 363.309 603.222 363.397C603.45 363.484 603.697 363.503 603.935 363.451C604.173 363.399 604.39 363.278 604.56 363.103C604.729 362.928 604.843 362.707 604.888 362.468C604.933 362.228 604.906 361.981 604.811 361.757C604.716 361.532 604.557 361.341 604.354 361.207C604.151 361.072 603.913 361 603.67 361C603.504 361.003 603.341 361.038 603.189 361.104C603.037 361.169 602.9 361.264 602.785 361.383C602.67 361.502 602.579 361.642 602.518 361.796C602.457 361.95 602.427 362.115 602.43 362.28Z",
    fill: "#868A91"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M269.77 245.85V322.85H341.87L339.61 313.94L344.91 291.15C345.27 289.438 345.378 287.683 345.23 285.94H333.79C332.735 285.945 331.71 285.59 330.884 284.934C330.059 284.277 329.482 283.359 329.25 282.33L323.48 255C323.34 254.341 323.353 253.658 323.518 253.005C323.682 252.351 323.994 251.744 324.43 251.23C324.87 250.707 325.42 250.288 326.04 250.001C326.66 249.714 327.336 249.567 328.02 249.57H334.02L332.41 244.47C332.119 243.561 331.547 242.767 330.775 242.205C330.004 241.642 329.074 241.339 328.12 241.34H274.29C273.696 241.339 273.109 241.454 272.561 241.68C272.012 241.906 271.514 242.238 271.094 242.657C270.674 243.076 270.341 243.574 270.114 244.122C269.887 244.669 269.77 245.257 269.77 245.85ZM290.12 253.34C290.066 252.865 290.113 252.384 290.259 251.928C290.405 251.472 290.645 251.053 290.964 250.697C291.283 250.341 291.674 250.056 292.111 249.862C292.548 249.668 293.021 249.568 293.5 249.57H311.5C312.54 249.573 313.547 249.933 314.354 250.59C315.16 251.248 315.716 252.162 315.93 253.18L322.15 285.45C322.282 286.046 322.278 286.665 322.138 287.26C321.998 287.855 321.726 288.41 321.341 288.885C320.957 289.36 320.47 289.742 319.918 290.002C319.365 290.263 318.761 290.395 318.15 290.39H304.92C302.201 290.437 299.549 289.544 297.412 287.863C295.274 286.181 293.783 283.814 293.19 281.16C293.13 280.83 293.07 280.49 293.04 280.16L290.12 253.34Z",
    fill: "#FFED00"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M328.231 314.198V296.288C328.229 294.299 328.024 292.316 327.621 290.368L318.761 247.998C318.647 247.461 318.353 246.979 317.927 246.631C317.502 246.284 316.97 246.092 316.421 246.088H287.921C287.589 246.088 287.262 246.158 286.958 246.292C286.655 246.427 286.384 246.623 286.161 246.868C285.936 247.111 285.764 247.399 285.657 247.712C285.55 248.026 285.511 248.358 285.541 248.688L291.121 314.178H290.321L284.751 248.758C284.711 248.318 284.765 247.874 284.908 247.455C285.051 247.036 285.28 246.653 285.581 246.328C285.881 246.01 286.244 245.757 286.647 245.585C287.049 245.413 287.483 245.325 287.921 245.328H316.421C317.153 245.333 317.861 245.587 318.428 246.049C318.996 246.511 319.388 247.153 319.541 247.868L328.391 290.218C328.811 292.218 329.022 294.255 329.021 296.298V314.198H328.231Z",
    fill: "black"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M318.229 290.398C318.84 290.402 319.443 290.268 319.995 290.007C320.546 289.746 321.032 289.364 321.417 288.889C321.801 288.415 322.073 287.86 322.214 287.266C322.355 286.672 322.36 286.054 322.229 285.458L315.999 253.188C315.786 252.17 315.23 251.256 314.424 250.599C313.617 249.942 312.61 249.581 311.569 249.578H293.569C293.091 249.577 292.618 249.676 292.181 249.87C291.744 250.065 291.353 250.349 291.034 250.705C290.715 251.061 290.474 251.481 290.329 251.936C290.183 252.392 290.136 252.873 290.189 253.348L293.189 280.178C293.189 280.518 293.279 280.858 293.339 281.178C293.929 283.822 295.409 286.183 297.531 287.865C299.654 289.547 302.291 290.449 304.999 290.418L318.229 290.398Z",
    fill: "#F4F4F4"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M345.291 285.928C345.177 284.612 344.912 283.314 344.501 282.058L334.001 249.578H328.001C327.317 249.573 326.64 249.72 326.02 250.007C325.399 250.294 324.85 250.714 324.411 251.238C323.977 251.754 323.667 252.361 323.502 253.014C323.338 253.667 323.323 254.349 323.461 255.008L329.231 282.318C329.461 283.348 330.037 284.268 330.863 284.925C331.689 285.581 332.715 285.935 333.771 285.928H345.291Z",
    fill: "#F4F4F4"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M269.66 313.82H339.66L340.01 315.18H269.66V313.82Z",
    fill: "black"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M268.08 327.788H343C343.62 327.788 343.62 322.238 343 322.238H305.54H268.08C267.46 322.238 267.46 327.788 268.08 327.788Z",
    fill: "#FFCF4A"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M316 253.188C315.787 252.17 315.231 251.256 314.425 250.599C313.618 249.942 312.611 249.581 311.57 249.578H306.87L292.73 276.698L293.12 280.178C293.12 280.518 293.21 280.858 293.27 281.178C293.582 282.7 294.206 284.141 295.103 285.409C296 286.678 297.15 287.746 298.48 288.548L316.23 254.448L316 253.188Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M316.74 257.098L300 289.348L300.64 289.598L316.99 258.178L316.74 257.098Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M317.271 259.867L301.621 289.937C302.444 290.169 303.288 290.317 304.141 290.377L318.001 263.727L317.271 259.867Z",
    fill: "#1C1C1C"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.04 249.578H332.88L325.4 263.948L328.84 280.238L338.15 262.348L334.04 249.578Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M338.87 264.578L329.41 282.758C329.502 283.038 329.619 283.309 329.76 283.568L339.17 265.498L338.87 264.578Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.631 266.93L330.471 284.52C331.053 285.109 331.781 285.534 332.581 285.75L340.681 270.2L339.631 266.93Z",
    fill: "#1C1C1C"
  }))), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M158.211 255.162C158.658 254.092 159.366 253.151 160.271 252.426C161.176 251.701 162.249 251.215 163.391 251.012H208.141C208.984 251.012 209.793 251.347 210.389 251.943C210.986 252.539 211.321 253.348 211.321 254.192V292.622H155.681C155.641 279.782 156.001 260.522 158.211 255.162Z",
    fill: "#FFED00"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M155.681 292.41H211.321V296.36H155.681C154.591 296.36 154.591 292.41 155.681 292.41Z",
    fill: "#FFCF4A"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M276.25 943.48H333V918.16H276.25V943.48Z",
    fill: "#FFED00"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M249.77 964H359.48V938.68H249.77V964Z",
    fill: "#FFED00"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M648.05 432.391H555.68V451.771H648.05V432.391Z",
    fill: "#49231F"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M652.87 450.941H550.58V456.261H652.87V450.941Z",
    fill: "#B2B6BB"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M653.521 450.941H571.971V456.261H653.521V450.941Z",
    fill: "#868A91"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M655.03 439.211H552.74V444.531H655.03V439.211Z",
    fill: "#B2B6BB"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M655.42 439.211H572.66V444.531H655.42V439.211Z",
    fill: "#868A91"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M650.411 445.078H548.221V450.398H650.411V445.078Z",
    fill: "#B2B6BB"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M654.06 445.078H569.68V450.398H654.06V445.078Z",
    fill: "#868A91"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M651.88 427.48H554.6V432.8H651.88V427.48Z",
    fill: "#B2B6BB"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M656.771 427.48H571.811V432.8H656.771V427.48Z",
    fill: "#868A91"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M650.519 433.352H549.699V438.672H650.519V433.352Z",
    fill: "#B2B6BB"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M659.001 433.352H568.311V438.672H659.001V433.352Z",
    fill: "#868A91"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M667.711 458.739L601.051 386.619C602.571 386.173 604.202 386.305 605.631 386.989L670.001 456.549L667.711 458.739Z",
    fill: "#21252B"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M669.999 456.551H537.439V465.011H669.999V456.551Z",
    fill: "#1C1C1C"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M669.999 456.551H537.439V465.011H669.999V456.551Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.e0470121db50586556b4231001c3ecd8.svg";
export { ForwardRef as ReactComponent };